<template>
    <div>
        <input-label v-if="label" :for_element="name" :label_class="label_class"> {{ $t(label) }}</input-label>

        <input :type="type"
            class="number field"
            :class="[
                input_class ? input_class : 'w-full',
                { 'read_only': read_only }
            ]"
            :name="name"
            :value="value"
            @input="$emit('input', $event.target.value)"
            v-bind="$attrs"
            ref="input"
            @keyup.enter="handleEnter"
            :readonly="read_only"
            :disabled="read_only"
        />
    </div>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        type: { default: 'number' },
        label: {},
        name: {},
        value: {},
        enter: { default: false },
        input_class: { default: null },
        label_class: { default: null },
        read_only: { default: false },
    },

    methods: {
        focus() {
            this.$refs.input.focus();
        },
        handleEnter() {
            if (this.enter) {
                this.enter();
            }
        },
    },
}
</script>

<style scoped>
    .read_only {
        background-color: #f7f7f7 !important;
        border-color: #f7f7f7 !important;
        color: #262626 !important;
    }

    .accordion .read_only {
        background-color: #fcfcfc !important;
    }

    .read_only::placeholder {
        color: transparent !important;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input.number {
        -moz-appearance: textfield;
    }
</style>
